export default __webpack_public_path__ + "static/media/VO_ServicesTriangles_2.073792e0.png";